export default "__VITE_ASSET__CCJZ7c88__"